import { useTranslation } from "next-i18next";
import { useContext } from "react";

import { Header } from "@baseComponents/Header";
import { CTA } from "@components/CTA";
import { BlogContext } from "@context/BlogContext";
import { portfolioArticleCards } from "@portfolios";

import { BlogLayout } from "./BlogLayout";
import {
  StyledArticlesMainLayout,
  StyledArticlesSeeAlso,
} from "./styles.styled";

export default function MDXPageEN() {
  const blogContext = useContext(BlogContext);

  const { t } = useTranslation();

  return (
    <BlogLayout
      title="Insights on UX, code, and teamwork"
      description="Explore how we work, the technologies we prefer, and the latest trends in UX/UI design. Our blog shares practical knowledge, inspirations, and thoughts from the world of modern software development and product design."
    >
      <Header
        header="Blog"
        subheader="Learn more about how we work, what solutions we like to use and the latest solutions from the world of UX/UI."
      />

      <StyledArticlesMainLayout
        articles={blogContext.getSortedArticleCards()}
      />

      <StyledArticlesSeeAlso
        articles={portfolioArticleCards.map(({ en }) => en)}
        sectionHeader={t("blog_page.see_also_header")}
        sectionSubheader={t("blog_page.see_also_subheader")}
      />

      <CTA
        buttonText="Get a Free Consultation"
        header="Let's talk about your project."
        subheader="Get a free consultation and see how we can bring your ideas to life."
      />
    </BlogLayout>
  );
}
